import React, { useMemo } from "react";
import { Row, Col, Button } from "reactstrap";
import { useGetInventoryId } from "api/inventory/service";
import { useTranslation } from "react-i18next";
import { getActiveColorStyle } from "utils/colorUtils";
import { getTheme2SearchFilterSingleSelectStyles } from "utils/theme2MultiSelect";
import { THEME2_SIDEBAR_NAV_FONT_SIZE_VAR } from "utils/sidebarShellTheme";
import Select from "components/Select";

const VEHICLE_MAKES = [
  "Acura","Aerolite","Airstream","Alfa","Aljo","Alpenlite","Ameri-Camp","Articat","Aston Martin","Audi","Baja Marine","Bentley","Berline","Big Dog","Big Foot","Blue Bird","BMW","Body","Bombardier","BRP","Buell","Buick","Cadillac","Can Am","Cargo Express","Carraige","Chevrolet","Chrysler","Club Car","Coachmen","Columbia ParCar","CPS","Cruiser RV","CTS","Daewoo","Daihatsu","Damon","Deck Boat Pro","Delorian","Dodge","Doonan","Doubletree RV","Dragon","Dutchmen","Eagle","Easy Come Easy Go Golf Cars","Extreme RV","Falcon","Featherlite","Ferrari","Fiat","Fleet Wood","Fleetwood","Fontaine","Ford","Forest River","Four Winds","Freightliner","Fruehauf","Geo","Georgia Boy","GMC","Golf Car Warehouse","Great Dane","Gulf Stream","Gulfstream","Harley-Davidson","Heartland RV","Hi Lo","Hill Billy","Hino","Holiday Rambler","Honda","Hummer","Hyundai","Infiniti","International","Isuzu","Jaguar","Jayco","Jeep","Jincheng","Kangaroo Products","Kawasaki","Kent Manufacturing","Kenworth","Key Stone","Keystone","Kia","King of the Road","Komfort","KZ","Lamborghini","Lance","Land Rover","Lexus","Lincoln","Lotus","Lufkin","Luxury Carts","Mack","Maserati","Mate","Mazda","McKenzie","Meiduo","Mercedes-Benz","Mercury","MG","Mini","Mitsubishi","Monaco","Nissan","None Available","Nu-Wa","Oldsmobile","Other","ParScooter.com","Peterbilt","Pilgrim International","PJ Trailers","Plymouth","Polaris","Pontiac","Porsche","Propel","R-Vision","RAM","Ranco","Roketa","Rolls Royce","Saab","Saturn","Scion","Shore Land R","Skyline","Smart","Starcraft","Sterling","STI Industrie","Subaru","Sugar Sand","Sunny Brook","Sunnybrook","Suzuki","Tahoe","Tesla","Teton","Tiempte","Toyota","Trailmanor","Transcraft","Triumph","UD","Utility","Verucci","Victory","Volkswagen","Volvo","Wabash","Western Star","Wildwood","Wilson","Winnebago","Yamaha","Yamaha Golf Car","ZAP","Zenn","Zhejiang","Zongshen"
];

const MILEAGE_STATUS_OPTIONS = [
  "Actual Miles",
  "True Mileage Unknown",
  "Beyond Mechnical Limits",
  "Exempt",
];

const DRIVE_TYPE_OPTIONS = [
  "2 Wheel Drive","2WD/4WD","4 Wheel Drive","4WD; Dual Rear Wheel","4WD; Dual Rear Wheels","4x2","4x2; Dual Rear Wheel","4x2; Dual Rear Wheels","4x4","4x4; Dual Rear Wheel","4x4; Dual Rear Wheels","6x2","6x4","8x4","All Wheel Drive","Front","Front Wheel Drive","FWD / AWD","FWD | AWD","N/A","Rear","Rear Wheel Drive","RWD / AWD","RWD | AWD","RWD; Dual Rear Wheel","RWD; Dual Rear Wheels","RWD; RWD","X"
];

const BODY_STYLE_OPTIONS = [
  "2 Door Coupe","2 Door SUV","4 Door Sedan","4 Door SUV","4 Door Van; Regular","4 Door Wagon","5th Wheel","Cargo Trailer","Class A","Class B","Class C","Convertible","Coupe - 2DR","Hatchback","Motorcycle","Scooter","Sedan - 4DR","SEDAN 4-DR","Sport Utility","SPORT UTILITY 4-DR","Tent Trailer","Toybox","Travel Trailer","Truck","Truck Camper","Van","Wagon"
];

const TRANSMISSION_OPTIONS = [
  "1 Speed Automatic","1-Speed Automatic","10-Speed Automatic","3 Speed Automatic","3-Speed Aut","3-Speed Automatic","3-Speed Automatic | 4-Speed Automatic","3-Speed Automatic | 4-Speed Automatic | 5-Speed Ma","3-Speed Automatic | 4-Speed Manual","3-Speed Automatic | 5-Speed Manual","3-Speed Automatic | 6-Speed Automatic","4 Speed Automatic","4 Speed Manual","4-Speed Aut","4-Speed Automatic","4-Speed Automatic | 4-Speed Manual","4-Speed Automatic | 4-Speed Manual | 5-Speed Manua","4-Speed Automatic | 5-Speed Automatic","4-Speed Automatic | 5-Speed Automatic | 5-Speed Ma","4-Speed Automatic | 5-Speed Automatic | 6-Speed Ma","4-Speed Automatic | 5-Speed Manual","4-Speed Automatic | 5-Speed Manual | 6-Speed Manua","4-Speed Automatic | 6-Speed Automatic","4-Speed Automatic | 6-Speed Manual","4-Speed Automatic Overdrive","4-Speed Automatic Overdrive | 5-Speed Automatic Ov","4-Speed Manual","5 Speed","5 Speed Automatic","5 Speed Manual","5-Speed Aut","5-Speed Automatic","5-Speed Automatic | 5-Speed Manual","5-Speed Automatic | 5-Speed Manual | 6-Speed Manua","5-Speed Automatic | 5-Speed Manual Overdrive","5-Speed Automatic | 6-Speed Automatic","5-Speed Automatic | 6-Speed Manual","5-Speed Automatic | 6-Speed Manual Overdrive","5-Speed Automatic | 7-Speed Automatic","5-Speed Automatic Overdrive","5-Speed Automatic Overdrive | 5-Speed Manual Overd","5-Speed Automatic Overdrive | 6-Speed Automatic Ov","5-Speed Man","5-Speed Manual","5-Speed Manual | 5-Speed Automatic Overdrive","5-Speed Manual | 6-Speed Automatic","5-Speed Manual | 6-Speed Manual","5-Speed Manual Overdrive","5-Speed Manual Overdrive | 4-Speed Automatic","5-Speed Manual Overdrive | 4-Speed Automatic Overd","5-Speed Manual Overdrive | 5-Speed Automatic Overd","5-Speed Manual Overdrive | CVT","6 Speed","6 Speed Automatic","6 Speed Manual","6-Speed Aut","6-Speed Automatic","6-Speed Automatic | 5-Speed Manual","6-Speed Automatic | 6-Speed Manual","6-Speed Automatic Overdrive","6-Speed Automatic Overdrive | 6-Speed Manual Overd","6-Speed Manua","6-Speed Manual","6-Speed Manual | 7-Speed Automatic","6-Speed Manual | 7-Speed Manual","6-Speed Manual | 8-Speed Automatic","6-Speed Manual Overdrive","6-Speed Manual Overdrive | 4-Speed Automatic","6-Speed Manual Overdrive | 6-Speed Automatic Overd","7 Speed Automatic","7-Speed Aut","7-Speed Automatic","7-Speed Automatic Overdrive","7-Speed Manual","8-Speed Automatic","8-Speed Automatic Overdrive","9-Speed Automatic","Automatic","Automatic CVT Overdrive","Continuously Variable Transmission","Continuously Variable Transmission | 5-Speed Manua","Continuously Variable Transmission | 6-Speed Autom","Continuously Variable Transmission | 6-Speed Manua","CVT","CVT | 5-Spe","CVT | 5-Speed Manual","CVT | 6-Speed Manual","Fuller Transmission/Rockwell Rear Axle","Manual","N/A","Semi-Hondamatic"
];

const CONDITION_OPTIONS = [
  "Unknown","Rough","Average","Clean","Extra Clean"
];

const ENGINE_OPTIONS = [
  "1 Cylinder","10 Cylinder","12 Cylinder","2 Cylinder","3 Cylinder","3.0L V6 DOHC 24V","4 Cylinder","4.0L V6 SOHC 12V","4.7L V8 DOHC 32V","5 Cylinder","5.0L V10 DOHC 40V","5.3L V8 OHV 16V","6 Cylinder","8 Cylinder","Rotary Engine"
];

const Collateral = ({ onFormChange, initialValues, prefillKey, onExistsChange, activeColor, isTheme2 = false }) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  const selectStyles = useMemo(
    () => getTheme2SearchFilterSingleSelectStyles(activeColorStyle, isTheme2),
    [activeColorStyle, isTheme2]
  );
  const inputStyle14 = isTheme2
    ? { fontSize: THEME2_SIDEBAR_NAV_FONT_SIZE_VAR }
    : { borderRadius: 0, fontSize: "14px" };
  const fieldStyle = (extra = {}) => ({ ...inputStyle14, ...extra });
  const [vin, setVin] = React.useState("");
  const [documentId, setDocumentId] = React.useState("");
  const [vinToFetch, setVinToFetch] = React.useState(null);
  const [year, setYear] = React.useState("");
  const [make, setMake] = React.useState("");
  const [model, setModel] = React.useState("");
  const [trim, setTrim] = React.useState("");
  const [stockNumber, setStockNumber] = React.useState("");
  const [mileage, setMileage] = React.useState("");
  const [mileageStatus, setMileageStatus] = React.useState("");
  const [exteriorColor, setExteriorColor] = React.useState("");
  const [interiorColor, setInteriorColor] = React.useState("");
  const [engine, setEngine] = React.useState("");
  const [bodyStyle, setBodyStyle] = React.useState("");
  const [transmission, setTransmission] = React.useState("");
  const [driveType, setDriveType] = React.useState("");
  const [condition, setCondition] = React.useState("");
  const [licensePlate, setLicensePlate] = React.useState("");
  const [valNumber, setValNumber] = React.useState("");
  const [installedOptions, setInstalledOptions] = React.useState("");

  const { data: decodedData, isLoading: isDecoding } = useGetInventoryId(vinToFetch,true);
  const [existingVinInfo, setExistingVinInfo] = React.useState(null);

  // Prefill support
  React.useEffect(() => {
    const iv = initialValues || {};
    
    // If we have inventory data, use it
    if (iv.inventory && iv.inventory.inventory_vehicle) {
      const inv = iv.inventory;
      const veh = inv.inventory_vehicle;
      
      setVin(veh.vin ?? "");
      setDocumentId(inv.documentId ?? "");
      setYear(veh.year ?? "");
      setMake(veh.make ?? "");
      setModel(veh.model ?? "");
      setTrim(veh.trim ?? "");
      setStockNumber(inv.stock_number ?? "");
      setMileage(inv.actual_mileage ?? inv.mileage ?? "");
      setMileageStatus(inv.actual_mileage_status ?? "");
      setExteriorColor(veh.exterior_color ?? "");
      setInteriorColor(veh.interior_color ?? "");
      setEngine(veh.engine ?? "");
      setBodyStyle(veh.body_style ?? "");
      setTransmission(veh.transmission ?? "");
      setDriveType(veh.drive_type ?? "");
      setCondition(veh.condition ?? "");
      setLicensePlate(veh.additional_vehicle_info?.plate_number ?? "");
      setValNumber("");
      setInstalledOptions("");
      
      // Notify parent that we have existing inventory data
      if (typeof onExistsChange === "function") {
        onExistsChange(true);
      }
    } else {
      // Use direct initial values if no inventory
      setVin(iv.vin ?? "");
      setYear(iv.year ?? "");
      setMake(iv.make ?? "");
      setModel(iv.model ?? "");
      setTrim(iv.trim ?? "");
      setStockNumber(iv.stockNumber ?? "");
      setMileage(iv.mileage ?? "");
      setMileageStatus(iv.mileageStatus ?? "");
      setExteriorColor(iv.exteriorColor ?? "");
      setInteriorColor(iv.interiorColor ?? "");
      setEngine(iv.engine ?? "");
      setBodyStyle(iv.bodyStyle ?? "");
      setTransmission(iv.transmission ?? "");
      setDriveType(iv.driveType ?? "");
      setCondition(iv.condition ?? "");
      setLicensePlate(iv.licensePlate ?? "");
      setValNumber(iv.valNumber ?? "");
      setInstalledOptions(iv.installedOptions ?? "");
    }
  }, [prefillKey, onExistsChange]);

  // Notify parent
  React.useEffect(() => {
    if (typeof onFormChange === "function") {
      onFormChange({
        vin,
        documentId,
        year,
        make,
        model,
        trim,
        stockNumber,
        mileage,
        mileageStatus,
        exteriorColor,
        interiorColor,
        engine,
        bodyStyle,
        transmission,
        driveType,
        condition,
        licensePlate,
        valNumber,
        installedOptions,
      });
    }
  }, [vin, documentId, year, make, model, trim, stockNumber, mileage, mileageStatus, exteriorColor, interiorColor, engine, bodyStyle, transmission, driveType, condition, licensePlate, valNumber, installedOptions, onFormChange]);

  const handleDecodeVin = () => {
    if (!vin || vin.length < 6) return;
    // Clear previous existing VIN info when starting new decode
    setExistingVinInfo(null);
    setVinToFetch(vin);
  };

  const pickFirst = (obj, keys) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (obj && obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
    }
    return "";
  };

  const normalizeMakeName = (raw) => {
    if (!raw || typeof raw !== 'string') return "";
    const target = raw.toLowerCase();
    const found = VEHICLE_MAKES.find((m) => m.toLowerCase() === target);
    return found || raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  };

  React.useEffect(() => {
    if (!decodedData) return;
    
    // Notify parent about exists status
    if (typeof onExistsChange === "function") {
      onExistsChange(decodedData?.exists);
    }
    
    // Two shapes possible:
    // 1) Our inventory object (exists=true): decodedData.data.attributes
    // 2) VIN-only decode (exists=false): decodedData.vpicData.Results[0]
    const src = decodedData?.data?.attributes || decodedData?.data || {};
    const vpic = decodedData?.vpicData?.Results?.[0];

    // If inventory already exists, prefer inventory payload entirely and show notice
    if (decodedData?.exists && decodedData?.inventory) {
      const inv = decodedData.inventory;
      const veh = inv.inventory_vehicle || {};
      setExistingVinInfo({ stockNumber: inv.stock_number });

      const nextYear = String(veh.year || "");
      const nextMake = normalizeMakeName(String(veh.make || ""));
      const nextModel = String(veh.model || "");
      const nextTrim = String(veh.trim || "");
      const nextBodyStyle = String(veh.body_style || "");
      const nextTransmission = String(veh.transmission || "");
      const nextEngine = String(veh.engine || "");
      const nextDriveType = String(veh.drive_type || "");

      const nextExt = String(inv.exterior_color || veh.exterior_color || "");
      const nextInt = String(inv.interior_color || veh.interior_color || "");
      const nextMileage = String(inv.actual_mileage || inv.mileage || "");
      const nextMileageStatus = String(inv.actual_mileage_status || "");
      const nextStock = String(inv.stock_number || "");
      const nextDocumentId = String(inv.documentId || "");

      if (nextDocumentId) setDocumentId(nextDocumentId);
      if (nextYear) setYear(nextYear);
      if (nextMake) setMake(nextMake);
      if (nextModel) setModel(nextModel);
      if (nextTrim) setTrim(nextTrim);
      if (nextBodyStyle) setBodyStyle(nextBodyStyle);
      if (nextTransmission) setTransmission(nextTransmission);
      if (nextEngine) setEngine(nextEngine);
      if (nextDriveType) setDriveType(nextDriveType);
      if (nextExt) setExteriorColor(nextExt);
      if (nextInt) setInteriorColor(nextInt);
      if (nextMileage) setMileage(nextMileage);
      if (nextMileageStatus) setMileageStatus(nextMileageStatus);
      if (nextStock) setStockNumber(nextStock);

      return;
    }

    // Clear existing VIN info if this VIN doesn't exist in our system
    setExistingVinInfo(null);

    // Prefer inventory fields if present
    const nextYear = String(pickFirst(src, ["year", "Year"])) || (vpic?.ModelYear || "");
    const nextMakeRaw = String(pickFirst(src, ["make", "Make"])) || (vpic?.Make || "");
    const nextModel = String(pickFirst(src, ["model", "Model"])) || (vpic?.Model || "");
    const nextTrim = String(pickFirst(src, ["trim", "Trim"])) || (vpic?.Trim || "");
    const nextBodyStyle = String(pickFirst(src, ["body_style", "bodyStyle", "BodyStyle"])) || (vpic?.BodyClass || "");
    const transStyle = vpic?.TransmissionStyle ? String(vpic.TransmissionStyle) : "";
    const transSpeeds = vpic?.TransmissionSpeeds ? String(vpic.TransmissionSpeeds) : "";
    const nextTransmission = String(pickFirst(src, ["transmission", "Transmission"])) || [transStyle, transSpeeds && `${transSpeeds}-Speed`].filter(Boolean).join(" ");
    const nextEngine = String(pickFirst(src, ["engine", "Engine"])) || (
      vpic && (vpic.DisplacementL || vpic.EngineCylinders)
        ? [vpic.DisplacementL ? `${Number(vpic.DisplacementL).toFixed(1)}L` : null, vpic.EngineCylinders ? `${vpic.EngineCylinders} Cylinder` : null].filter(Boolean).join(" ")
        : ""
    );
    const nextDriveType = String(pickFirst(src, ["drive_type", "driveType", "Drivetrain"])) || (vpic?.DriveType || "");

    const nextMake = normalizeMakeName(nextMakeRaw);

    if (nextYear) setYear(nextYear);
    if (nextMake) setMake(nextMake);
    if (nextModel) setModel(nextModel);
    if (nextTrim) setTrim(nextTrim);
    if (nextBodyStyle) setBodyStyle(nextBodyStyle);
    if (nextTransmission) setTransmission(nextTransmission);
    if (nextEngine) setEngine(nextEngine);
    if (nextDriveType) setDriveType(nextDriveType);

    // Optional fields when present in our inventory shape
    const nextStock = String(pickFirst(src, ["stock", "stock_number", "stockNumber", "Stock"])) || "";
    if (nextStock) setStockNumber(nextStock);
    const nextMileage = String(pickFirst(src, ["mileage", "odometer", "Odometer"])) || "";
    if (nextMileage) setMileage(nextMileage);
    const nextMileageStatus = String(pickFirst(src, ["mileage_status", "mileageStatus"])) || "";
    if (nextMileageStatus) setMileageStatus(nextMileageStatus);
    const nextExt = String(pickFirst(src, ["exterior_color", "exteriorColor", "colorExterior"])) || "";
    if (nextExt) setExteriorColor(nextExt);
    const nextInt = String(pickFirst(src, ["interior_color", "interiorColor", "colorInterior"])) || "";
    if (nextInt) setInteriorColor(nextInt);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedData]);

  // Clear form when VIN input changes (but not when it's just being typed)
  React.useEffect(() => {
    if (!vinToFetch) {
      setExistingVinInfo(null);
    }
  }, [vinToFetch]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="mb-3">
          <label className='font-weight-bold mr-3'>{t('addAccount.enterCollateralVin')} <span style={{ color: 'red' }}>*</span></label>
          <input
            type="text"
            className="form-control d-inline-block"
            style={fieldStyle({ maxWidth: 320, marginRight: 8, borderColor: !vin ? 'red' : undefined })}
            value={vin}
            onChange={(e) => setVin(e.target.value)}
            placeholder={t('addAccount.vin')}
          />
          <Button size="sm" color="secondary" onClick={handleDecodeVin} disabled={isDecoding}>
            {isDecoding ? t('addAccount.decoding') : t('addAccount.decode')}
          </Button>
        </div>
        {existingVinInfo && (
          <div className="alert alert-warning mt-2" role="alert" style={{ borderRadius: 0 }}>
            <strong>{t('addAccount.activeVinAlreadyExists')}</strong> — {t('addAccount.stockNumber')}: {existingVinInfo.stockNumber || '-'}
          </div>
        )}

        <h6 className='info-text mb-3'>{t('addAccount.collateralInformation')}</h6>

        <Row>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.year')} <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" value={year} onChange={(e) => setYear(e.target.value)} style={fieldStyle({ borderColor: !year ? 'red' : undefined })} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.make')} <span style={{ color: 'red' }}>*</span></label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectMake')}
                name="make"
                isSearchable
                closeMenuOnSelect={true}
                value={make ? { value: make, label: make } : null}
                onChange={(option) => setMake(option?.value || "")}
                options={VEHICLE_MAKES.map(m => ({ value: m, label: m }))}
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.model')} <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" value={model} onChange={(e) => setModel(e.target.value)} style={fieldStyle({ borderColor: !model ? 'red' : undefined })} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.trim')}</label>
              <input type="text" className="form-control" value={trim} onChange={(e) => setTrim(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.stockNumber')} <span style={{ color: 'red' }}>*</span></label>
              <input type="text" className="form-control" value={stockNumber} onChange={(e) => setStockNumber(e.target.value)} style={fieldStyle({ borderColor: !stockNumber ? 'red' : undefined })} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.mileage')}</label>
              <input type="text" className="form-control" value={mileage} onChange={(e) => setMileage(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.mileageStatus')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectStatus')}
                name="mileageStatus"
                isSearchable={false}
                closeMenuOnSelect={true}
                value={mileageStatus ? { value: mileageStatus, label: mileageStatus } : null}
                onChange={(option) => setMileageStatus(option?.value || "")}
                options={MILEAGE_STATUS_OPTIONS.map(s => ({ value: s, label: s }))}
                isClearable
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.exteriorColor')}</label>
              <input type="text" className="form-control" value={exteriorColor} onChange={(e) => setExteriorColor(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.interiorColor')}</label>
              <input type="text" className="form-control" value={interiorColor} onChange={(e) => setInteriorColor(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.bodyStyle')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectBodyStyle')}
                name="bodyStyle"
                isSearchable={false}
                closeMenuOnSelect={true}
                value={bodyStyle ? { value: bodyStyle, label: bodyStyle } : null}
                onChange={(option) => setBodyStyle(option?.value || "")}
                options={BODY_STYLE_OPTIONS.map(b => ({ value: b, label: b }))}
                isClearable
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.transmission')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectTransmission')}
                name="transmission"
                isSearchable
                closeMenuOnSelect={true}
                value={transmission ? { value: transmission, label: transmission } : null}
                onChange={(option) => setTransmission(option?.value || "")}
                options={TRANSMISSION_OPTIONS.map(t => ({ value: t, label: t }))}
                isClearable
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.driveType')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectDriveType')}
                name="driveType"
                isSearchable={false}
                closeMenuOnSelect={true}
                value={driveType ? { value: driveType, label: driveType } : null}
                onChange={(option) => setDriveType(option?.value || "")}
                options={DRIVE_TYPE_OPTIONS.map(dt => ({ value: dt, label: dt }))}
                isClearable
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.engine')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectEngine')}
                name="engine"
                isSearchable={false}
                closeMenuOnSelect={true}
                value={engine ? { value: engine, label: engine } : null}
                onChange={(option) => setEngine(option?.value || "")}
                options={ENGINE_OPTIONS.map(eo => ({ value: eo, label: eo }))}
                isClearable
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.condition')}</label>
              <Select
                activeColor={activeColor}
                styles={selectStyles}
                className="react-select"
                placeholder={t('addAccount.selectCondition')}
                name="condition"
                isSearchable={false}
                closeMenuOnSelect={true}
                value={condition ? { value: condition, label: condition } : null}
                onChange={(option) => setCondition(option?.value || "")}
                options={CONDITION_OPTIONS.map(c => ({ value: c, label: c }))}
                isClearable
              />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.licensePlateNumber')}</label>
              <input type="text" className="form-control" value={licensePlate} onChange={(e) => setLicensePlate(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label>{t('addAccount.valNumber')}</label>
              <input type="text" className="form-control" value={valNumber} onChange={(e) => setValNumber(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <div className="form-group mb-0">
              <label>{t('addAccount.installedOptions')}</label>
              <textarea className="form-control" rows={3} value={installedOptions} onChange={(e) => setInstalledOptions(e.target.value)} style={inputStyle14} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Collateral;


